export enum DeviceStatus {
    Pending = 'pending',
    Approved = 'approved'
};

export enum DeviceRole {
    Warehouse = 'warehouse',
    Harvest = 'harvest'
};
